"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticRenewalCancellationConfirmationModal = void 0;
var React = require("react");
var Modal_1 = require("reactstrap/lib/Modal");
var ModalHeader_1 = require("reactstrap/lib/ModalHeader");
var ModalBody_1 = require("reactstrap/lib/ModalBody");
var services_1 = require("@falcon/services");
var ModalFooter_1 = require("reactstrap/lib/ModalFooter");
var AutomaticRenewalCancellationConfirmationModal = function (_a) {
    var isOpen = _a.isOpen, onAgreeToAutoRenewal = _a.onAgreeToAutoRenewal, onConfirmToCancelAutoRenewal = _a.onConfirmToCancelAutoRenewal, product = _a.product;
    return (React.createElement(Modal_1.default, { className: "automatic-renewal-modal", isOpen: isOpen, toggle: onAgreeToAutoRenewal, id: "automaticRenewalModal" },
        React.createElement(ModalHeader_1.default, { toggle: onAgreeToAutoRenewal },
            React.createElement("div", { className: "d-flex" },
                React.createElement("img", { className: "info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon" }),
                React.createElement("span", { className: "text-blue-2 fs-20 font-weight-medium" }, "Automatic renewal"))),
        React.createElement(ModalBody_1.default, { className: "pt-0" },
            React.createElement("p", { className: "font-weight-extra-light" },
                "To make things easy, we can ",
                React.createElement("span", { className: "font-weight-semi-bold" }, "set up your policy to renew automatically"),
                " next year but you can always opt out if you change your mind."),
            React.createElement("p", { className: "font-weight-extra-light" },
                "We want to give you the ",
                React.createElement("span", { className: "font-weight-semi-bold" }, "reassurance of our continuous cover "),
                product === services_1.ProductsEnum.WOLF_MOTOR && React.createElement(React.Fragment, null, "as car insurance is a legal requirement and, "),
                "as you\u2019re in control, you\u2019ll have ",
                React.createElement("span", { className: "font-weight-semi-bold" }, "plenty of time to review"),
                " your renewal quote either way."),
            React.createElement("p", { className: "font-weight-extra-light mb-0" }, services_1.resourcesHelper.WHATEVER_YOU_DECIDE)),
        React.createElement(ModalFooter_1.default, null,
            React.createElement("div", { className: "renewalModalButtonContainer" },
                React.createElement("button", { type: "button", className: "btn btn-white mb-0 w-100", onClick: onAgreeToAutoRenewal }, "Ok, auto-renew"),
                React.createElement("button", { type: "button", className: "btn btn-white mb-0 w-100", onClick: onConfirmToCancelAutoRenewal, id: "noAutoRenewal" }, "I don't want to auto-renew")))));
};
exports.AutomaticRenewalCancellationConfirmationModal = AutomaticRenewalCancellationConfirmationModal;
//# sourceMappingURL=AutomaticRenewalCancellationConfirmationModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/modals/AutomaticRenewalCancellationConfirmationModal.js
// module id = 1241
// module chunks = 0